import Vue from 'vue'
import { gsap } from 'gsap'

Vue.directive('gsap', (el, binding) => {
  const options = { ...binding.value }
  const modifiers = binding.modifiers

  if (modifiers.set) {
    gsap.set(el, options)
  }

  if (modifiers.to) {
    gsap.to(el, options)
  }

  if (modifiers.from) {
    gsap.from(el, options)
  }

  if (modifiers.fromTo) {
    gsap.fromTo(el, { ...binding.value[0] }, { ...binding.value[1] })
  }
})

export default ({ app }, inject) => {
  inject('gsap', gsap)

      if (process.client) {
          const { Flip } = require('gsap/Flip')
          inject('Flip', Flip)
          gsap.registerPlugin(Flip)

          const { ScrollTrigger } = require('gsap/ScrollTrigger')
          inject('ScrollTrigger', ScrollTrigger)
          gsap.registerPlugin(ScrollTrigger)

          const { Observer } = require('gsap/Observer')
          inject('Observer', Observer)
          gsap.registerPlugin(Observer)

          const { ScrollToPlugin } = require('gsap/ScrollToPlugin')
          inject('ScrollToPlugin', ScrollToPlugin)
          gsap.registerPlugin(ScrollToPlugin)

          const { Draggable } = require('gsap/Draggable')
          inject('Draggable', Draggable)
          gsap.registerPlugin(Draggable)

          const { MotionPathPlugin } = require('gsap/MotionPathPlugin')
          inject('MotionPathPlugin', MotionPathPlugin)
          gsap.registerPlugin(MotionPathPlugin)

          const { ExpoScaleEase } = require('gsap/EasePack')
          inject('ExpoScaleEase', ExpoScaleEase)
          gsap.registerPlugin(ExpoScaleEase)

          const { DrawSVGPlugin } = require('gsap/DrawSVGPlugin')
          inject('DrawSVGPlugin', DrawSVGPlugin)
          gsap.registerPlugin(DrawSVGPlugin)

          const { ScrollSmoother } = require('gsap/ScrollSmoother')
          inject('ScrollSmoother', ScrollSmoother)
          gsap.registerPlugin(ScrollSmoother)

          const { InertiaPlugin } = require('gsap/InertiaPlugin')
          inject('InertiaPlugin', InertiaPlugin)
          gsap.registerPlugin(InertiaPlugin)

          const { SplitText } = require('gsap/SplitText')
          inject('SplitText', SplitText)
          gsap.registerPlugin(SplitText)
      }
}
